export default "__VITE_ASSET__8bd08f7f__"